import React from 'react'
import {Box, Popover, Stack, ToggleButton, ToggleButtonGroup, Typography} from "@mui/material"
import {RowDataset} from "../../api/enum/RowDataset"

interface DatasetFilterPopoverProps {
    anchorEl: HTMLElement | null
    onClose: () => void
    dataset?: RowDataset
    onDatasetChange: (d?: RowDataset) => void
}

function DatasetFilterPopover({anchorEl, onClose, dataset, onDatasetChange}: DatasetFilterPopoverProps) {
    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
            transformOrigin={{vertical: 'top', horizontal: 'left'}}
            PaperProps={{sx: {mt: 0.5, minWidth: 280}}}
        >
            <Box sx={{p: 2}}>
                <Stack spacing={2}>
                    <Box>
                        <Typography variant="overline" color="text.secondary" sx={{display: 'block', mb: 0.5}}>
                            Dataset
                        </Typography>
                        <ToggleButtonGroup
                            value={dataset ?? 'ALL'}
                            exclusive
                            size="small"
                            fullWidth
                            onChange={(_e, value) => {
                                if (value === null) return
                                onDatasetChange(value === 'ALL' ? undefined : value as RowDataset)
                            }}
                        >
                            <ToggleButton value="ALL">All</ToggleButton>
                            <ToggleButton value={RowDataset.TRAINING}>Training</ToggleButton>
                            <ToggleButton value={RowDataset.VALIDATION}>Validation</ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                </Stack>
            </Box>
        </Popover>
    )
}

export default DatasetFilterPopover
